<template>
  <div class="container-admin">
    <router-view></router-view>
  </div>
</template>


<script>
export default {
  name: 'navbar',
  created() {
    if (!this.$store.getters.role.admin) {
      this.$router.push({ name: 'homePage' });
    }
  },
};
</script>
